module.exports = __webpack_public_path__ + "images/category_lp/furniture/main-view-sp_8be66cef96de774c48002010265ed8a6.png";